import emitterDataConfigApi from '@/api/config/emitterDataConfig'
import { queryKeys } from '@/constant/common'
import { CreateEmitter } from '@/types/emitter'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function create(payload: CreateEmitter): Promise<void> {
  await emitterDataConfigApi.create(payload)
}

function useAddEmitter() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreateEmitter) => create(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.emitter])
      toast.success(t('addEmitterSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 404) {
        toast.error(error?.message)
      } else toast.error(t('addEmitterError'))
    },
  })
}

export default useAddEmitter
